import { cx, FeaturedIcon } from "@light-technology/components";
import { UploadCloud02 } from "@untitledui/icons";
import {
  Button,
  DropZone,
  FileTrigger,
  type FileDropItem,
} from "react-aria-components";

const mime = "image/png";

type ImageDropProps = {
  height: number;
  width: number;
  src: string | null;
  onFile: (file: File) => void;
  className?: string;
  isDisabled?: boolean;
};

export const ImageDrop = (props: ImageDropProps) => {
  return (
    <DropZone
      isDisabled={props.isDisabled}
      getDropOperation={(types) => (types.has(mime) ? "copy" : "cancel")}
      onDrop={async (e) => {
        const item = e.items.find(
          (i): i is FileDropItem => i.kind === "file" && i.type === mime,
        );
        if (item) {
          const file = await item.getFile();
          props.onFile(file);
        }
      }}
    >
      <FileTrigger
        acceptedFileTypes={[mime]}
        onSelect={(e) => {
          if (e) {
            for (const file of e) {
              if (file.type === mime) {
                props.onFile(file);
              }
            }
          }
        }}
      >
        <Button
          className={cx(
            props.className,
            "flex cursor-pointer flex-col items-center justify-center gap-lg rounded-xl border border-secondary px-3xl py-xl hover:border-primary",
          )}
          isDisabled={props.isDisabled}
        >
          {props.src ? (
            <img
              className="object-contain"
              height={props.height}
              width={props.width}
              src={props.src}
            />
          ) : (
            <FeaturedIcon
              color="gray"
              theme="modern"
              size="md"
              icon={UploadCloud02}
            />
          )}
          <div className="text-sm text-tertiary">
            <span className="font-semibold">Click to upload</span> or drag and
            drop
          </div>
        </Button>
      </FileTrigger>
    </DropZone>
  );
};
